const baseUrl = (window.globals && window.globals.UC_BASE_URL) || 'http://0.0.0.0:8000';
export const userEndPoint = `${baseUrl}/mns/mnsusers/info/`;
export const offersEndpoint = `${baseUrl}/mns/offer/`;
export const subscriptionEndpoint = `${baseUrl}/mns/mnsusers/create_subscription_offer/`;
